// extracted by mini-css-extract-plugin
module.exports = {"sortableItem":"style_sortableItem__3n9cnCrHEPKt2Ye5JckboO","name":"style_name__2zG9O2ry8q1ct01VKedrBL"};